import moment from 'moment';
import Moment from 'react-moment';
import { webmasterConstants } from '../../constants/webmaster';
import calendar_translation from '../../translations/calendar.json';
import { defaultLocale } from '../../config';

import 'moment/locale/ru';

const getTranslatedMonths = locale => {
  return calendar_translation[locale].months;
};

export const getTranslatedMonthsShort = locale => {
  const months = calendar_translation[locale].monthsShort.split('_');
  return {
    format: months,
    standalone: months,
  };
};

const getTranslatedWeeks = locale => {
  return calendar_translation[locale].weeks;
};

const updateLocale = locale => {
  moment.updateLocale('en', {
    months : getTranslatedMonths(locale),
    weekdaysMin: getTranslatedWeeks(locale),
    monthsShort: getTranslatedMonthsShort(locale),
    week: {
      dow: locale === 'ru' ? 1 : 0,
    }
  });
};

export const setLang = store => next => action => {
  if (action.type === webmasterConstants.LOGIN_SUCCESS) {
    const language = action.profile.language;
    if(language) {
      updateLocale(language);
      Moment.globalLocale = language;
    } else {
      updateLocale(defaultLocale);
      Moment.globalLocale = defaultLocale;
    }
  }
  return next(action);
};